// Cheap checks that run in the main bundle, before the backdrop chunk is fetched.

interface NetworkInformationLike {
  readonly saveData?: boolean
}

export function backdropSupported(): boolean {
  if (typeof WebGL2RenderingContext === 'undefined' || typeof createImageBitmap === 'undefined') return false
  const connection = (navigator as Navigator & { connection?: NetworkInformationLike }).connection
  return connection?.saveData !== true
}

// Defers work until the first route has rendered and the main thread is idle.
export function whenIdle(callback: () => void): () => void {
  if (typeof requestIdleCallback === 'function') {
    const handle = requestIdleCallback(callback, { timeout: 3000 })
    return () => cancelIdleCallback(handle)
  }
  const handle = setTimeout(callback, 1200)
  return () => clearTimeout(handle)
}
